import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=148ec16e&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=148ec16e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148ec16e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148ec16e')) {
      api.createRecord('148ec16e', component.options)
    } else {
      api.reload('148ec16e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=148ec16e&scoped=true", function () {
      api.rerender('148ec16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/Index.vue"
export default component.exports